// "Jan 5, 2026" — the reader shows an absolute publication date, unlike the loop, which
// shows relative recency.
export const formatReaderDate = (value?: string | null): string =>
  value ? new Date(value).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : '';
